<template>
  <Card class="NotificationsEditFilters">
    <CardSection v-if="notification.type === 'manual'" class="section">
      <Stack
        distribution="equalSpacing"
      >
        <Checkbox
          label="Send to all Subscribers"
          v-model="isBroadcastMessage"
          :disabled="noEditing"
        />

        <div v-if="!isBroadcastMessage" id="BrowserCountTop" class="BrowserCount">{{$t('NotificationsApp.Targeted Subscribers')}}: {{ targetedCount !== null ? targetedCount : '-' }}</div>
      </Stack>
    </CardSection>
    <CardSection v-if="!isBroadcastMessage" class="section">
      <Stack distribution="fillEvenly" spacing="extraLoose">

        <div v-if="notification.type === 'manual'">
          <Heading>{{$t('NotificationsApp.OS and Browser')}}</Heading>
          <div class="BrowserChoice">
            <div v-for="os in osBrowser" :key="os.id">
              <div class="BrowserChoice-Os"><div class="Icon-Os" :class="[ os.id ]"></div><div class="Os-Name">{{os.name}}</div></div>
              <ul>
                <li v-for="browser in os.browsers" :key="browser.id" @click="clickBrowser(browser.id)" :class="{ 'Icon-Disabled': !chosenOsBrowser.includes(browser.id) }">
                  <div class="Icon-Browser" :class="[ browser.id.split('-')[1] ]"></div>
                  <div class="Browser-Name">{{browser.name}} ({{$t('NotificationsApp.Subscribers')}}: {{ counts ? counts[browser.id] || 0 : '-' }})</div>
                  <div class="Check">
                    <Checkbox
                      :checked="chosenOsBrowser.includes(browser.id)"
                      :disabled="noEditing"
                      class="check switch"
                    />
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div>
          <FormLayout>
            
            <Select
              :label="$t('Language')"
              v-model="language"
              :options="store.languages"
              :disabled="noEditing"
            />

            <Select
              :label="$t('Domain')"
              v-model="domain"
              :placeholder="$t('All domains')"
              :options="optionsDomains"
              :disabled="noEditing"
              :multiple="true"
            />

            <FormLayoutGroup v-if="notification.type === 'manual'">
              <DatePicker :label="$t('NotificationsApp.Users active from')" v-model="startDate" />
              <DatePicker :label="$t('To')" v-model="endDate" />
            </FormLayoutGroup>

          </FormLayout>
        </div>
      </Stack>

    </CardSection>
    <CardSection class="section" v-if="!isBroadcastMessage && notification.type === 'manual'">
      <Heading>{{$t('NotificationsApp.Extra Filters')}}</Heading>
      <LoadingLayout v-if="!filterPanelLoaded" :card="false" />
      <InsightsFilterPanel v-model="filters.ui" @result="filterResult" @loaded="filterLoad" />
    </CardSection>
    <CardSection class="section BroadcastMessage-Info" v-if="isBroadcastMessage">
      <p>{{$t('NotificationsApp.This notification will be sent to all subscribers')}}</p>
    </CardSection>
    <CardSection v-if="!theUser.isDemoAccount && notification.status == 'draft'">
      <Button type="primary" @click="changePage('details')">{{$t('Save + Next')}}</Button>
    </CardSection>
    <CardSection v-if="!theUser.isDemoAccount && notification.status !== 'draft' && (notification.type === 'welcome')" class="section border">
      <Button type="primary" @click="changePage('filters')">{{$t('Save')}}</Button>
    </CardSection>
  </Card>
</template>

<script>

import _ from 'lodash'
import moment from 'moment'
import OsBrowser from '../data/OsBrowser'
import InsightsFilterPanel from '@/insights/InsightsFilterPanel.vue'
import NotificationUtils from '../classes/NotificationUtils.class'

export default {
  name: 'NotificationsEditFilters',
  inject: ['store'],
  props: {
    notification: Object
  },
  data() {
    return {
      isBroadcastMessage: false,
      language: null,
      chosenOsBrowser: [],
      domain: [],
      osBrowser: OsBrowser,
      startDate: '',
      endDate: '',
      filters: {
        ui: [],
        server: []
      },
      filterPanelLoaded: false,
      filterPanelValid: true,
      notifications: [],
      counts: null,
      targetedCount: null,
      missingWelcomeMessages: null,
      existingTriggeredMessages: null,
      defCopy:null
    };
  },
  computed: {
    optionsDomains() {
      return this.arrayToOptions(this.store.domains)
    },
    noEditing() {
      return this.notification.type === 'manual' && this.notification.status !== 'draft'
    }
  },
  mounted() {
    const segments = this.notification.segments || {}
    this.language = segments.browserLanguage && segments.browserLanguage[0]

    this.domain = segments.domain ? segments.domain.filter(d => !!d) : []
    try {
      this.$set(this, 'filters', JSON.parse(this.notification.filters))
    } catch (e) {
      this.$set(this, 'filters', {
        ui: [],
        server: []
      })
    }

    this.isBroadcastMessage = this.notification.isBroadcastMessage || false

    if (this.notification.type === 'manual') {
      const osBrowserCombinations = []
      if (segments.osBrowserCombinations) {
        Object.keys(segments.osBrowserCombinations).forEach((k) => {
          Object.values(segments.osBrowserCombinations[k]).forEach((v) => {
            osBrowserCombinations.push(`${k}-${v}`)
          })
        })
      }
      this.chosenOsBrowser = osBrowserCombinations

      this.startDate = ((this.notification.segments && this.notification.segments.startDate) || moment().subtract(1, 'years').format('YYYY-MM-DD 00:00:00')).substr(0, 19)
      this.endDate = ((this.notification.segments && this.notification.segments.endDate) || moment().format('YYYY-MM-DD 00:00:00')).substr(0, 19)

    } else if (this.notification.type === 'welcome') {
      // for welcome and triggered we don't want to allow to choose browser
      // so add all ...
      const osBrowserCombinations = []
      for (let i = 0; i < OsBrowser.length; i += 1) {
        for (let j = 0; j < OsBrowser[i].browsers.length; j += 1) {
          osBrowserCombinations.push(OsBrowser[i].browsers[j].id)
        }
      }
      this.chosenOsBrowser = osBrowserCombinations

      // load notifications for messaging
      this.loadNotifications()
    }

    //
    this.setupRefreshCountsDebounce()

    if (this.notification.type === 'manual') {
      this.$watch('language', this.refreshCounts)
      this.$watch('domain', this.refreshCounts)
      this.$watch('startDate', this.refreshCounts)
      this.$watch('endDate', this.refreshCounts)
    }

    this.$watch('chosenOsBrowser', () => {
      this.updateTargeted()
    })
    this.defCopy = _.cloneDeep({
      chosenOsBrowser: this.chosenOsBrowser,
      language: this.language ? [this.language] : [],
      domain: this.domain,
      filters: this.filters,
      startDate: this.startDate,
      endDate: this.endDate,
      isBroadcastMessage: this.isBroadcastMessage
    })
  },
  components: {
    InsightsFilterPanel
  },
  methods: {
    updateTargeted() {
      this.targetedCount = 0
      if (this.counts) {
        Object.keys(this.counts).forEach((key) => {
          if (this.chosenOsBrowser.includes(key)) {
            this.targetedCount += this.counts[key]
          }
        })
      }
    },
    setupRefreshCountsDebounce() {
      this.refreshCountsDebounced = _.debounce(() => {
        this.counts = null
        this.targetedCount = null

        const notification = JSON.parse(JSON.stringify(this.notification))

        notification.segments = notification.segments || {}
        notification.segments.browserLanguage = this.language ? [this.language] : []
        notification.segments.domain = this.domain
        notification.segments.startDate = `${this.startDate} 00:00:00`
        notification.segments.endDate = `${this.endDate} 00:00:00`
        notification.filters = JSON.stringify(this.filters)

        NProgress.start()
        this.api.getNotificationCount(notification)
          .then((response) => {
            this.counts = {}
            response.counts.forEach((count) => {
              const os = count.os.toLowerCase()
              const browser = count.browser.toLowerCase()
              // if (os === 'android') {
              //   browser = 'general'
              // }
              // for some reason the API is sending back multiple pairs so handle that
              if (!this.counts[`${os}-${browser}`]) {
                this.counts[`${os}-${browser}`] = count.count
              }
            })
            this.updateTargeted()
          })
          .catch((err) => {
            console.log(err)
            this.apiCatch(err.message)
          })
          .finally(() => {
            NProgress.done()
          })
      }, 5000, {
        leading: true,
        trailing: true
      })
    },
    refreshCounts() {
      this.refreshCountsDebounced()
    },
    loadNotifications() {
      NProgress.start()
      this.api.notifications.getNotifications()
        .then((response) => {
          this.notifications = response.notifications
          if (this.notification.type === 'welcome') {
            this.missingWelcomeMessages = NotificationUtils.getMissingWelcomeMessages(this.notifications, this.store)
            if (Object.keys(this.missingWelcomeMessages).length === 0) {
              this.missingWelcomeMessages = null
            }
          }
        })
        .catch((error) => {
          this.apiCatch(error.message)
        })
        .finally(() => {
          NProgress.done()
        })
    },
    arrayToOptions(arr) {
      return arr.map(d => ({
        label: d.domain,
        value: d.domain
      }))
    },
    async changePage(nextPage, forceSave = true) {
      if (forceSave) {
        if (!this.filterPanelValid) {
          this.$ui.alert({ title: this.$t('NotificationsApp.Please fix your extra filters') })
          return
        }
        this.$emit('update', {
          nextPage,
          chosenOsBrowser: this.chosenOsBrowser,
          language: this.language ? [this.language] : [],
          domain: this.domain,
          filters: this.filters,
          startDate: this.startDate,
          endDate: this.endDate,
          isBroadcastMessage: this.isBroadcastMessage
        })
      } else {
        if (!_.isEqual(this.defCopy, {
          chosenOsBrowser: this.chosenOsBrowser,
          language: this.language ? [this.language] : [],
          domain: this.domain,
          filters: this.filters,
          startDate: this.startDate,
          endDate: this.endDate,
          isBroadcastMessage: this.isBroadcastMessage
        })) {
          const res = await this.$ui.confirm({
            title: this.$t('Unsaved Changes'),
            content: this.$t('messaging.loseChangesMessage'),
            primaryActionLabel: this.$t('Discard changes'),
            primaryActionType: 'destructive',
            secondaryActionLabel: this.$t('Continue editing')
          })
          if (!res) return;
        }
        this.$emit('goToPage', nextPage)
      }
    },
    clickBrowser(browser) {
      if (this.chosenOsBrowser.includes(browser)) {
        this.chosenOsBrowser.splice(this.chosenOsBrowser.indexOf(browser), 1)
      } else {
        this.chosenOsBrowser.push(browser)
      }
    },
    filterResult(serverRulesets) {
      this.filterPanelValid = !!serverRulesets
      if (this.filterPanelValid) {
        this.filters.server = serverRulesets
        this.refreshCounts()
      }
    },
    filterLoad() {
      console.log('loaded insights')
      this.filterPanelLoaded = true
    }
  }
};
</script>

<style lang="scss" scoped>
  .BrowserChoice {
    .BrowserChoice-Os {
      float: left;
      padding-top: 10px;
      .Icon-Os {
        width: 30px;
        height: 30px;
        background-position: center center;
        background-repeat: no-repeat;
        background-size: contain;
        margin-bottom: -20px;
        &.macos {
          background-image: url(../assets/icon-macos.png);
        }
        &.windows {
          background-image: url(../assets/icon-windows.png);
        }
        &.android {
          background-image: url(../assets/icon-android.png);
        }
      }
      .Os-Name {
        position: relative;
        top: -5px;
        left: 40px;
      }
    }
    ul {
      padding-left: 0px;
      margin-top: 15px;
      li {
        cursor: pointer;
        list-style-type: none;
        border-bottom: 1px solid #f0f0f0;
        margin-left: 110px;
        padding-bottom: 10px;
      }
      .Check {
        .UIElement {
          width: 0px;
          float: right;
          position: relative;
          top: -12px;
          right: 7px;
        }
      }
    }
  }
  #BrowserCountTop {
    text-align: right;
    font-weight: bold;
  }
  .BrowserCount-Total {
    margin-top: 15px;
    margin-bottom: 15px;
    font-weight: bold;
    color: #000;
  }
  .Icon-Browser {
    width: 20px;
    height: 20px;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: contain;
    float: left;
    margin-right: 15px;
    margin-left: 10px;
    margin-top: 12px;
    &.chrome {
      background-image: url(../assets/icon-chrome.png);
    }
    &.firefox {
      background-image: url(../assets/icon-ff.png);
    }
    &.edge {
      background-image: url(../assets/icon-edge.png);
    }
    &.general {
      background-image: url(../assets/icon-android-general.png);
    }
  }
  .Browser-Name {
    margin-top: 12px;
    display: inline-block;
  }
  .Icon-Disabled .Icon-Browser {
    filter: grayscale(100%);
  }
  .missing-welcome-messages {
    h2 {
      font-size: 100%;
    }
    & > ul {
      padding: 0px;
      margin-bottom: 0px;
    }
    & > ul ul {
      padding: 5px;
    }
    ul {
      list-style-type: none;
    }
  }
  .BroadcastMessage-Wrapper {
    cursor: pointer;
    position: relative;
    width: 240px;
    * {
      pointer-events: none;
    }
    .BroadcastMessage-Text {
      position: absolute;
      right: 60px;
    }
    .material-switch {
      float: right;
    }
  }
  .BroadcastMessage-Info {
    p {
      text-align: center;
      font-size: 120%;
      color: #999;
    }
  }
</style>
